import { Link } from '@material-ui/core'
import React from 'react'

const ErrorAccessingMagentoMessage: React.FC = () => (
  <React.Fragment>
    Your account does not have access to shop on this site. If you are a Private Label customer,
    please visit <Link href="https://pl.designsforhealth.com">https://pl.designsforhealth.com</Link>{' '}
    to shop.
  </React.Fragment>
)

export default ErrorAccessingMagentoMessage
